import Home from './routes/Home.svelte';
import Sdf from './routes/Sdf.svelte';
import Ddf from './routes/Ddf.svelte';
import Qdf from './routes/Qdf.svelte';
import Sdt from './routes/Sdt.svelte';
import Ddt from './routes/Ddt.svelte';

export default {
    '/': Home,
    '/sdf': Sdf,
    '/ddf': Ddf,
    '/qdf': Qdf,
    '/sdt': Sdt,
    '/ddt': Ddt,
};